module.exports = __webpack_public_path__ + "img/bg02.e3c38c7b.png";